import React from 'react'
import { Container } from '../Style'
import FiltroTipoData from './filtroTipoData'
import { FiltroDataSimples } from './filtroDataSimples'
import { useFiltroEdital } from './context/FiltroEditaisContext'
import FiltroPregao from './filtroPregao'
import CardData from './filtroData'

const FilterDailyBulletin = ({ status, isFetching }) => {
  const { state, showFiltro, filtrarEditaisStatus } = useFiltroEdital()

  return (
    <>
      {state.filtro && !isFetching && (
        <Container>
          <div
            style={{
              display: 'flex',
              marginTop: '50px',
              flexWrap: 'wrap',
              justifyContent: 'center',
              overflow: 'auto',
              height: '100%',
              paddingBottom: '50px'
            }}
          >
            <CardData />
            <FiltroTipoData />

            <div className="action-buttons">
              <button
                id="filtrar-editais"
                className="icon-scale-xs"
                onClick={() => filtrarEditaisStatus(status)}
              >
                FILTRAR
              </button>
              <button
                id="fechar-modal-filtro-editais"
                className="icon-scale-xs"
                onClick={() => showFiltro(false)}
              >
                FECHAR
              </button>
            </div>
          </div>
        </Container>
      )}
    </>
  )
}

export default FilterDailyBulletin
